<div class="page-content">
    <div class="container-fluid">
        <p>auth form!</p>

    </div>
</div>